import React from 'react'
import { Button } from 'semantic-ui-react'

import { getStaticPath } from '../../utils'


class IconField extends React.Component {

  constructor(props) {
    super(props)
    this.inputRef = React.createRef()

    this.state = {
      newIcon: null,
    }
  }

  handleFileBtn = (e) => {
    e.preventDefault()
    this.inputRef.current.click()
  }

  handleFileSelect = (e) => {
    const file = e.target.files[0]
    this.props.onChange(file)

    const reader = new FileReader()
    reader.onloadend = () => {
      this.setState({ newValue: reader.result })
    }
    reader.readAsDataURL(file)
  }

  render() {
    const { value } = this.props
    const { newValue } = this.state
    return (
      <div>
        <Button
          basic color='blue' size='mini' icon='image'
          content={value ? 'Заменить' : 'Выбрать'}
          onClick={this.handleFileBtn}
          style={{ marginBottom: '5px' }}
        />
        <div>
          {value || newValue ?
            <img
              src={newValue ? newValue : getStaticPath(value)}
              style={{ maxHeight: '150px', maxWidth: '150px' }}/> :
            null}
        </div>
        <input
          type='file'
          style={{ display: 'none' }}
          ref={this.inputRef}
          accept='image/*'
          onChange={this.handleFileSelect}
        />
      </div>
    )
  }

}

export default IconField